import request, { METHODS } from '@/api'
import UrlConfig from '@/api/UrlConfigs.ts'

// 获取最后的消息列表
export const getLastMessage = async () => {
  return request(`${UrlConfig.PNS.getLastMessage}`, {
    method: METHODS.GET,
  })
}

// 获取消息列表
export const getMessage = async (data, size = 10) => {
  return request(`${UrlConfig.PNS.getMessages}/${size}`, {
    method: METHODS.POST,
    data,
  })
}

// 获取未读消息数量
export const getUnReadCount = async params => {
  return request(`${UrlConfig.PNS.getUnReadCount}`, {
    method: METHODS.GET,
    params,
    error: false
  })
}
